import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductModel, ProductResponseModel } from 'src/app/models/Home/home-list.model';
import { GetProductAssetModel } from 'src/app/models/product/productAssets.modal';
import { DeleteQuoteListModel, QuoteAddressModel, QuoteItemModel } from 'src/app/models/quoteModel/quote.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { QuoteService } from 'src/app/services/quote.service';

@Component({
  selector: 'app-quote-view-list',
  templateUrl: './quote-view-list.component.html',
  styleUrls: ['./quote-view-list.component.css']
})
export class QuoteViewListComponent implements OnInit {

  Loader: boolean = false;
  productId: number;
  quoteId: number;
  quoteItemVm: QuoteItemModel = new QuoteItemModel();
  quoteImageListModel: ProductResponseModel = new ProductResponseModel();
  quoteAddressListing: QuoteAddressModel = new QuoteAddressModel();
  productAssets: GetProductAssetModel = new GetProductAssetModel();
  productDetail: ProductModel = new ProductModel();
  deleteQuoteList: DeleteQuoteListModel = new DeleteQuoteListModel();

  constructor(private route: ActivatedRoute, private requestQuote: QuoteService, private alertify: AlertifyService, private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.route.params.subscribe((param) => {
      this.productId = +param.id;
      this.quoteId = +param.addressId;
    })
    this.quoteSingleImage();
    this.quoteSingleDetail();
    this.getProductAssetsContent();
  }

  quoteSingleImage() {
    this.Loader = true;
    this.quoteItemVm.ProductId = this.productId;
    this.requestQuote.QuoteImageList(this.quoteItemVm.ProductId)
      .subscribe((response) => {
        this.Loader = false;
        let responseimage = JSON.parse(response._body)
        if (responseimage.isSuccess) {
          this.quoteImageListModel.ProductSort = responseimage.responseData;
        } (err) => {
        }
      })
  }

  quoteSingleDetail() {
    this.Loader = true;
    this.quoteItemVm.Id = this.quoteId;
    this.requestQuote.QuoteAddressList(this.quoteItemVm.Id)
      .subscribe((response) => {
        this.Loader = false;
        let responseBody = JSON.parse(response._body)
        if (responseBody.isSuccess) {
          this.quoteAddressListing = responseBody.responseData;
          this.alertify.success(responseBody.responseMessage);
        } else {
          this.alertify.error(responseBody.responseMessage);
        }
      })
  }

  getProductAssetsContent() {
    this.Loader = true;
    this.productAssets.ProductId = this.productId;
    this.requestQuote.GetProductDetail(this.productAssets)
      .subscribe((response) => {
        let responseBody = JSON.parse(response._body)
        if (responseBody.isSuccess) {
          this.productDetail = responseBody.responseData;
          this.Loader = false;
        } (err) => {
          this.Loader = false;
        }
      })
  }

  cancelButton() {
    this.router.navigate(['/admin-quote-listing']);
  }

  quoteViewImage() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/product-page/' + this.productId]));
    window.open('#' + url, '_blank');
  }

}
